var isPrimitive = {};
export {
  isPrimitive as __exports
};
//# sourceMappingURL=isPrimitive.js.map
